import React from 'react';

const Liver = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M8 3c-2 0-3.5 1.5-4 3.5-.5 2-1 4.5 0 7 1 2.5 3 4 5.5 4.5 2.5.5 5 0 7-.5 2-.5 3.5-2 4-4 .5-2 0-4.5-1-6.5-1-2-2.5-3.5-4.5-4-2-.5-4.5-.5-7 0z"/>
    <path d="M12 8v8"/>
    <path d="M9 11h6"/>
  </svg>
);

export default Liver;
